import React from "react";
import "./ourCommitment.scss";
import {
  card1_bg,
  card1_icon,
  card1_icon_light,
  card2_icon,
  card2_icon_light,
  card3_icon,
  card3_icon_light,
  card4_img,
} from "../../source";
import { useWindowSize } from "react-use";

const OurCommitment = () => {
  const { width } = useWindowSize();
  return (
    <>
      <div className="row commit_row">
        <div
          className="col-lg-5 col-md-6 commit_col"
          data-aos="fade-up"
          data-aos-delay={100}
        >
          <div className="title_commit_box">
            <h2 className="section_title">
              DRIVEN BY EXCELLENCE, GUIDED BY <span>INTEGRITY</span>
            </h2>
          </div>
        </div>

        {width <= 767 && (
          <div className="col-lg-5 col-md-6 commit_col" data-aos="fade-up">
            <div className="desc_commit_box">
              <p className="section_desc">
                At Protrans Logistics, we are committed to redefining logistics
                through seamless and sustainable solutions. With a foundation
                built on transparency and trust, we empower businesses to
                navigate the complexities of global trade. Every shipment, every
                mile, and every partnership reflects our unwavering dedication
                to precision, reliability, and customer satisfaction.
              </p>
            </div>
          </div>
        )}

        <div className="col-lg-7 col-md-6 commit_col">
          <div className="row commit_inner_row">
            <div
              className="col-lg-6 col-md-12 commit_inner_col"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="commit_box">
                <img
                  src={card1_bg}
                  alt="background"
                  width={450}
                  height={450}
                  className="card_bg"
                />
                <div className="card_data">
                  <img
                    src={card1_icon}
                    alt="impact"
                    width={70}
                    height={70}
                    className="card_icon card_dark"
                  />
                  <img
                    src={card1_icon_light}
                    alt="icon"
                    width={70}
                    height={70}
                    className="card_icon card_light"
                  />
                  <h3 className="section_title36">Impact</h3>
                  <p className="section_desc">
                    Help businesses streamline supply chain operations, reduce
                    costs, and improve time-to-market.
                  </p>
                </div>
              </div>
            </div>
            {width > 991 && (
              <div
                className="col-lg-6 col-md-6 commit_inner_col"
                data-aos="fade-up"
                data-aos-delay={300}
              >
                <div className="commit_box commit_box_blue">
                  <img
                    src={card1_bg}
                    alt="background"
                    width={450}
                    height={450}
                    className="card_bg"
                  />
                  <div className="card_data">
                    <img
                      src={card2_icon}
                      alt="impact"
                      width={70}
                      height={70}
                      className="card_icon card_light"
                    />
                    <img
                      src={card2_icon_light}
                      alt="icon"
                      width={70}
                      height={70}
                      className="card_icon card_dark"
                    />
                    <h3 className="section_title36">Vision</h3>
                    <p className="section_desc">
                      To become a leading logistics provider in the Middle East,
                      known for innovation and operational excellence.
                    </p>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        {width <= 991 && width > 767 && (
          <div
            className="col-lg-5 col-md-6 commit_col"
            data-aos="fade-up"
            data-aos-delay={200}
          >
            <div className="desc_commit_box">
              <p className="section_desc">
                At Protrans Logistics, we are committed to redefining logistics
                through seamless and sustainable solutions. With a foundation
                built on transparency and trust, we empower businesses to
                navigate the complexities of global trade. Every shipment, every
                mile, and every partnership reflects our unwavering dedication
                to precision, reliability, and customer satisfaction.
              </p>
            </div>
          </div>
        )}

        {width <= 991 && (
          <div
            className="col-md-6 commit_col"
            data-aos="fade-up"
            data-aos-delay={300}
          >
            <div className="commit_box commit_box_blue">
              <img
                src={card1_bg}
                alt="background"
                width={450}
                height={450}
                className="card_bg"
              />
              <div className="card_data">
                <img
                  src={card2_icon}
                  alt="impact"
                  width={70}
                  height={70}
                  className="card_icon card_light "
                />
                <img
                  src={card2_icon_light}
                  alt="icon"
                  width={70}
                  height={70}
                  className="card_icon card_dark"
                />
                <h3 className="section_title36">Vision</h3>
                <p className="section_desc">
                  To become a leading logistics provider in the Middle East,
                  known for innovation and operational excellence.
                </p>
              </div>
            </div>
          </div>
        )}

        {width > 991 && (
          <div
            className="col-lg-5 col-md-6 commit_col"
            data-aos="fade-up"
            data-aos-delay={100}
          >
            <div className="desc_commit_box">
              <p className="section_desc">
                At Protrans Logistics, we are committed to redefining logistics
                through seamless and sustainable solutions. With a foundation
                built on transparency and trust, we empower businesses to
                navigate the complexities of global trade. Every shipment, every
                mile, and every partnership reflects our unwavering dedication
                to precision, reliability, and customer satisfaction.
              </p>
            </div>
          </div>
        )}

        <div className="col-lg-7 col-md-12 commit_col commit_inner_col_img">
          <div className="row commit_inner_row">
            <div
              className="col-md-6 commit_inner_col commit_inner_col_mb"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="commit_box commit_box_blue">
                <img
                  src={card1_bg}
                  alt="background"
                  width={450}
                  height={450}
                  className="card_bg"
                />

                <div className="card_data">
                  <img
                    src={card3_icon}
                    alt="impact"
                    width={70}
                    height={70}
                    className="card_icon card_light"
                  />
                  <img
                    src={card3_icon_light}
                    alt="icon"
                    width={70}
                    height={70}
                    className="card_icon card_dark "
                  />
                  <h3 className="section_title36">Mission</h3>
                  <p className="section_desc">
                    To provide seamless, efficient, and cost-effective logistics
                    solutions that facilitate global movement of goods.
                  </p>
                </div>
              </div>
            </div>

            {width > 767 && (
              <div
                className="col-md-6 commit_inner_col"
                data-aos="fade-up"
                data-aos-delay={600}
              >
                <div className="commit_box commit_image_box">
                  <img
                    src={card4_img}
                    alt="impact"
                    width={450}
                    height={450}
                    className="box_img"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default OurCommitment;
